<template>
  <div class="main">
    <report-top
      ><ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <div id="formTable">
      <div id="formTable">
        <div class="formTableItem">
          <p class="label">时间范围</p>
          <start-end ref="startEnd" timeModel="2,3,0,1"></start-end>
        </div>
        <div class="formTableItem">
          <p class="label">选择车辆</p>
          <selecAlotCCar
            ref="selecAlotCCar"
            @deviceIdList="searchItem.deviceIdList = $event"
          ></selecAlotCCar>
        </div>
        <div class="formTableItem">
          <p class="label">选择报警</p>
          <selecAlotAlarmSafe
            ref="selecAlotCCar"
            @alarmIdList="searchItem.alarmIdList = $event"
          ></selecAlotAlarmSafe>
        </div>
        <div class="formTableItem">
          <Button @click="exportAll" type="error" class="chaxun">导出</Button>
          <Button @click="chaxun" type="primary" class="chaxun">查询</Button>
        </div>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(240)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="detail(row)">查看明细</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <ascSelectDetail ref="ascSelectDetail"></ascSelectDetail>
  </div>
</template>
<script>
import selecAlotAlarmSafe from "../common/selecAlotAlarmSafe.vue";
import ascSelectDetail from "./ascSelectDetail.vue";

export default {
  components: { selecAlotAlarmSafe, ascSelectDetail },
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
          align: "center"
        },
        {
          title: "车牌号",
          key: "carNo",
          minWidth: 100,
          maxWidth: 200
        },
        {
          title: "设备号",
          key: "deviceNo",
          minWidth: 100,
          maxWidth: 200
        },
        {
          title: "报警名称",
          key: "alarmTypeName",
          minWidth: 200,
          maxWidth: 300
        },
        {
          title: "一级报警",
          key: "firstLevel",
          minWidth: 100,
          maxWidth: 200
        },
        {
          title: "二级报警",
          key: "secondLevel",
          minWidth: 100,
          maxWidth: 200
        },

        {
          title: "三级报警",
          key: "thirdLevel",
          minWidth: 100,
          maxWidth: 200
        },
        {
          title: "总次数",
          key: "total",
          minWidth: 100,
          maxWidth: 200
        },
        {
          title: "单位名称",
          key: "groupName",
          minWidth: 200,
          maxWidth: 300
        },
        {
          title: "事件描述",
          key: "evetDesc",
          minWidth: 200,
          maxWidth: 300
        },
        {
          title: "操作",
          slot: "action",
          width: 90,
          align: "center",
          fixed: "right"
        }
      ],
      tableData: [],
      total: 0,
      searchItem: {
        endTime: 0,
        startTime: 0,
        alarmIdList: [],
        deviceIdList: [],
        keyword: "",
        pageNumber: 1,
        pageSize: 50
      }
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.alarm + "/alarmAsc/sum",
        data: this.searchItem
      }).then(res => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data.dataList;
          this.tableData = data;
        }
      });
    },
    exportAll() {
      var params = [
        {
          name: "deviceIdList",
          value: this.searchItem.deviceIdList
        },
        {
          name: "startTime",
          value: this.searchItem.startTime
        },
        {
          name: "endTime",
          value: this.searchItem.endTime
        }
      ];
      this.utils.exportData(
        this.axios.ipPort + "/cloud-common-server-alarm/alarmAsc/export/sum",
        params
      );
    },
    search() {
      this.getList();
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    openMap(v) {
      var obj = {
        address: v.address,
        lng: v.x,
        lat: v.y
      };
      this.$refs.lymap.open(obj);
    },
    detail(v) {
      this.$refs.ascSelectDetail.open(v);
    }
  },
  mounted() {
    this.chaxun();
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// ../common/src/components/alarm/ascSelect.vue